  <template>
    <div>
        <NavBar/>
        <div class="page">
            <div class="col left-sidebar">
                <p class="heading"> Book A Meeting </p>
                <div class="section">
                    <p class="heading"> {{ counselor_name }} </p>
                    <form @submit.prevent="submitForm">
                      <label for="link">Zoom Link</label>
                      <br>
                      <br>
                      <input type="text" placeholder="Link" v-model="zoom_link">
                      <br>
                      <br>
                      <!-- <input type="text" placeholder="Time" v-model="meeting_time"> -->
                      <label for="time">Meeting Time</label>
                      <br>
                      <br>
                      <input type="datetime-local" placeholder="Time" v-model="meeting_time">
                      <br>
                      <br>
                      <!-- <input type="number" placeholder="Hours" v-model="meeting_duration"> -->
                      <!-- Dropdown of 30 minute increments up to 3 hours -->
                      <!-- Create input dropdown of friends, counselor ID as value, counselor_name as what shows-->
                      <label for="duration">Counselor to Book</label>
                      <br>
                      <br>
                      <select v-model="counselor_to_get">
                        <option v-for="friend in friends" :value="friend.counselor_id" :key="friend.counselor_id">
                          {{ friend.counselor_name + " " + friend.counselor_id}}
                        </option>
                      </select>
                      <br>
                      <br>

                      <label for="duration">Meeting Duration</label>
                      <br>
                      <br>
                      <select v-model="meeting_duration">
                        <option value="30">30 minutes</option>
                        <option value="60">1 hour</option>
                        <option value="90">1 hour 30 minutes</option>
                        <option value="120">2 hours</option>
                        <option value="150">2 hours 30 minutes</option>
                        <option value="180">3 hours</option>
                      </select>
                      <br>
                      <br>
                      <label for="meeting_topic">Meeting Topic</label>
                      <br>
                      <br>
                      <input type="text" placeholder="Meeting Topic" v-model="meeting_topic">
                      <br>
                      <br>
                      <button id="submit" type="submit">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
  </template>

<script>
const API_BASE = process?.env?.VUE_APP_API_BASE_URL ?? '/api';
import { useRouter } from 'vue-router';
import NavBar from './../components/NavBar.vue'
import Auth from '../auth/auth.js'

export default {

  name: 'CreateMeetingAuth',
  components:{
      NavBar
  },

  props:{
    // counselor_user_id: String,
    // counselor_name: String
  },

  setup() {
    const router = useRouter();
    return { router };
  },
  data() {
    return {
      zoom_link: '',
      meeting_time: '',
      meeting_duration: '',
      error: '',
      friends: [],
    };
  },
  mounted() {
    this.fetchUserFriends();
  },
  methods: {
    async submitForm() {
      const userData = {
          student_user_id: Auth.getUserID(),
          counselor_user_id: this.counselor_to_get,
          link: this.zoom_link,
          time: this.meeting_time,
          meeting_topic: this.meeting_topic,
          duration: this.convertIntDurationToDateTime(this.meeting_duration),
      };

      console.log(userData);

      fetch(`${API_BASE}/add-meeting`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(userData)
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        // Redirect to home page
        window.location.href = '/';
      })
      .catch(error => {
        console.error(error);
      });
    },
    fetchUserFriends() {
      fetch(`${API_BASE}/get-user-friends?student_id=${Auth.getUserID()}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          console.log(data);
          this.friends = data.friends;
        })
        .catch(error => console.error("Failed to fetch user data:", error));
    },
    convertIntDurationToDateTime(duration){
      let hours = Math.floor(duration / 60);
      let minutes = duration % 60;
      return `${hours}:${minutes}:00`;
    }
  }
}
</script>
  
  <style scoped>
  .page {
      font-family: 'Your Font', sans-serif;
      color: #333;
      background-color: #3867AE; /* Set the page background to blue */
      min-height: 100vh; /* Full viewport height */
      padding: 20px;
      display: flex;
      justify-content: center; /* Center the .left-sidebar horizontally */
      align-items: flex-start; /* Align to the top */
  }
  
  .left-sidebar {
      background-color: #fff; /* Keep the sidebar white for contrast */
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      border-radius: 8px;
      width: 100%; /* Make the sidebar full-width */
      max-width: 600px; /* Or any max-width you prefer */
      margin: 20px auto; /* Center in the page */
      padding: 20px;
      box-sizing: border-box; /* Include padding in the width */
  }
  
  .heading {
      color: #000000; /* Changed to white for better contrast against blue background */
      font-size: 1.5em;
      margin-bottom: 10px;
      text-align: left; /* Align headings to the left */
  }
  
  .section {
      border-top: 2px solid #ffffff; /* Use a contrasting color for the section divider */
      padding-top: 20px;
  }
  
  ul {
      padding: 0;
      margin: 0;
  }
  
  li {
      list-style: none;
      padding: 10px 0;
      border-bottom: 1px solid #eee; /* Light border for list items */
      display: flex;
      align-items: center; /* Align items in the li */
      gap: 10px; /* Spacing between icon and text */
  }
  
  li:last-child {
      border-bottom: none;
  }
  
  img {
      width: 50px;
      height: 50px;
  }
  
  a {
      color: #ffcc00; /* Keep the specific yellow hue for links */
      text-decoration: none;
  }
  
  a:hover {
      text-decoration: underline;
  }
  
  /* Style the buttons/links like the homepage ones */
  a.button {
      background-color: #ffcc00; /* Use the brand yellow for buttons */
      color: #0044cc; /* Blue text on yellow button for contrast */
      padding: 10px 15px;
      border-radius: 20px;
      display: inline-block;
      margin-top: 20px;
      text-align: center;
      text-decoration: none;
  }
  
  a.button:hover {
      background-color: #ffbb00; /* A slightly darker yellow on hover */
  }
  </style>